import CarouselAbstr, { CarouselOptions } from '../CarouselAbstr';
import Slide from '../Slide';

import * as $ from 'jquery';

export default class testimonialStripe extends CarouselAbstr {
	constructor(options: CarouselOptions) {
		super(options);

		this.init();

		this.adjustHeight(0);

		this.onChange = this.transitionHeight;
	}

	protected init(): void {
		const slidesColl = this.carouselEl.getElementsByClassName('testimonialStripe__slide');
		for (let i = 0; i < slidesColl.length; i++) {
			const element = slidesColl[i];
			const isActive = i === 0;
			this.slides.push(new Slide({ element, isActive }));
		}

		if (this.slides.length === 1)
			return;

		document.querySelector('.testimonialStripe__inner').appendChild(this.buildControls());
	}

	private adjustHeight = (duration: number = 325) => {
		// Adjust height of slideDeck as necessary
		const newSlideHeight = this.slides[this.state.currentIndex].element.getBoundingClientRect().height;
		const oldFrameHeight = this.carouselFrameEl.getBoundingClientRect().height;
		$(this.carouselFrameEl).animate({
			'height': `${newSlideHeight}px`
		 }, duration);
	}

	private transitionHeight = () => { this.adjustHeight() };	
}
